var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "ds-custom-drop-tree_chooseDialog",
      attrs: {
        title: "请选择：",
        width: "800px",
        visible: _vm.visible,
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "main",
          class: {
            noConst: _vm.noConst,
            noData: !(_vm.loading || _vm.data.length || _vm.keyWord),
          },
        },
        [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c(
                "div",
                { staticClass: "input-box" },
                [
                  _c("div", { staticClass: "head" }, [_vm._v("自定义：")]),
                  _c("el-input", {
                    attrs: {
                      resize: "none",
                      type: "textarea",
                      placeholder: "输入自定义数据",
                      rows: 2,
                    },
                    model: {
                      value: _vm.inputValue,
                      callback: function ($$v) {
                        _vm.inputValue = $$v
                      },
                      expression: "inputValue",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "head" },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: {
                        indeterminate: _vm.checkConfig.isIndeterminate,
                        disabled: _vm.data.length == 0,
                      },
                      on: { change: _vm.checkAll },
                      model: {
                        value: _vm.checkConfig.checkAll,
                        callback: function ($$v) {
                          _vm.$set(_vm.checkConfig, "checkAll", $$v)
                        },
                        expression: "checkConfig.checkAll",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.loading || _vm.data.length || _vm.keyWord
                              ? "常量："
                              : "暂无常量"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm.loading || _vm.data.length || _vm.keyWord
                ? _c(
                    "el-input",
                    {
                      staticClass: "searchBox",
                      attrs: { clearable: "", placeholder: "输入关键字" },
                      model: {
                        value: _vm.keyWord,
                        callback: function ($$v) {
                          _vm.keyWord = $$v
                        },
                        expression: "keyWord",
                      },
                    },
                    [
                      _c("template", { slot: "suffix" }, [
                        _c("i", {
                          staticClass: "el-icon-search",
                          attrs: { title: "搜索" },
                        }),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.loading || _vm.data.length || _vm.keyWord
                ? _c(
                    "div",
                    { staticClass: "list" },
                    [
                      _c(
                        "dsf-virtual-scroll",
                        {
                          attrs: { "scroll-x": "" },
                          on: { scroll: _vm.paginationScroll },
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading",
                                },
                              ],
                              attrs: {
                                "element-loading-text": "数据加载中",
                                "element-loading-spinner": "el-icon-loading",
                              },
                            },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  on: { change: _vm.changeState },
                                  model: {
                                    value: _vm.checkConfig.constChoose,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.checkConfig,
                                        "constChoose",
                                        $$v
                                      )
                                    },
                                    expression: "checkConfig.constChoose",
                                  },
                                },
                                _vm._l(_vm.data, function (item) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: item.id,
                                      attrs: {
                                        label: item.index,
                                        disabled: item.choosed,
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(item.name) + " ")]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c("DsfButton", { on: { click: _vm.chooseFn } }, [
                _vm._v("选择 >"),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "right" }, [
            _c("div", { staticClass: "head el-row" }, [
              _c("div", { staticClass: "ellipsis el-col el-col-12" }, [
                _vm._v(" 已选择 "),
                _c(
                  "b",
                  {
                    staticClass: "chooseNum",
                    class: {
                      over: _vm.maxLength
                        ? _vm.value.length > _vm.maxLength
                        : false,
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.value.length || 0) +
                        _vm._s(_vm.maxLength ? "/" + _vm.maxLength : "") +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "ellipsis el-col el-col-12" }, [
                _c("span", { on: { click: _vm.resetFn } }, [
                  _c("i", { staticClass: "el-icon-refresh-right" }),
                  _vm._v("重置 "),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "list" },
              [
                _c(
                  "dsf-virtual-scroll",
                  { attrs: { "scroll-x": "" } },
                  _vm._l(_vm.value, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "item",
                        attrs: { label: item.id },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(index + 1) +
                            ". " +
                            _vm._s(item.name) +
                            " "
                        ),
                        _c("i", {
                          staticClass: "iconfont icon-guanbi2",
                          class: { isInput: item.isInput },
                          attrs: { title: item.isInput ? "自定义数据" : "" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteFn(item, index)
                            },
                          },
                        }),
                      ]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "dsf-button",
            { attrs: { type: "plain" }, on: { click: _vm.closeFn } },
            [_vm._v(" 取消 ")]
          ),
          _c("dsf-button", { on: { click: _vm.sureFn } }, [_vm._v(" 确定 ")]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }